if (!customElements.get('klaviyo-form')) {
  const KlaviyoForm = class extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector('.klaviyo-form-container');
      this.statusContainer = this.querySelector('.form-status');
      this.form = this.querySelector('form');
      this.listId = this.form.dataset.listId;
      
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    async handleSubmit(evt){
      evt.preventDefault();
      evt.stopImmediatePropagation();

      const formData = new FormData(this.form);

      const payload = {
        "data": {
          "type": "subscription",
          "attributes": {
            "custom_source":"form",
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": this.form.querySelector('.email').value,
                  "phone_number": this.form.querySelector('.phone').value,
                },
              },
            },
          },
          "relationships": {
            "list": {
              "data": {
                "type": "list",
                "id": this.listId
              }
            }
          }
        }
      }

      var requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision":"2026-01-15"
          },
          body: JSON.stringify(payload),
      };

      const res = await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=PjKgix",requestOptions)
          .then(res => {return res;})
          .catch(error => console.log('error', error));

      if(res.ok && res.ok == true){
        this.querySelector('.form-status').innerHTML = `<p>You're added in the list!</p>`;
        // this.form.classList.add('hidden');
        this.form.reset();
        /* remove after 5 seconds */
        setTimeout(() => {
          this.querySelector('.form-status').innerHTML = '';
          // this.form.classList.remove('hidden');
        }, 5000);
      }
    }
  }
  window.customElements.define('klaviyo-form', KlaviyoForm);
}